module.exports = __webpack_public_path__ + "img/jj-2.d13c3ad4.jpg";